module.exports = "mat-dialog-content {\n  min-width: 350px; }\n"